import React from "react"
// import { useDispatch, useSelector } from "react-redux"
import { useRouter } from "next/router"
import axios from "axios"
import Head from "next/head"
import { captureException } from "@sentry/nextjs"
import { Container, Row, Col } from "react-bootstrap"

// import { getPropertyData } from "@/slices/getPropertySlice"

import HeroImage from "@/singleProperty/heroImage"
import SinglePropertyCard from "@/singleProperty/singlePropertyCard"
import PropertyFeatures from "@/singleProperty/propertyFeatures"
import FullDetails from "@/singleProperty/fullDetails"
import HomeToSell from "@/singleProperty/homeToSell"
import Nearby from "@/singleProperty/nearby"
import InterestedCard from "@/singleProperty/interestedCard"
import BottomSticky from "@/singleProperty/bottomSticky"

import Loader from "@/main/loader"

function SinglePropertyScreen({ staticProperty }) {
    const router = useRouter()

    if (router.isFallback) {
        return <Loader />
    }

    const url = `https://webbjenkins.co.uk/properties/${staticProperty.property_ref}`
    const title = `${staticProperty.display_address} - Webb Jenkins`
    const description = staticProperty.summary
    const imgUrl =
        staticProperty.images[0]?.imgix_url ||
        `https://webb-jenkins-236939759.imgix.net/${staticProperty.images[0]?.image_url}`
    const imgAlt = `Property ${staticProperty.property_ref} main`

    return (
        <>
            <Head>
                <link rel="canonical" href={url} />
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta property="fb:app_id" content="362437448786240" />
                <meta property="og:title" content={title} />
                <meta property="og:image:url" content={imgUrl} />
                <meta property="og:image:alt" content={imgAlt} />
                <meta property="og:description" content={description} />
                <meta property="og:url" content={url} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image:src" content={imgUrl} />
                <meta name="twitter:site" content="@WebbJenkinsIOW" />
            </Head>

            <HeroImage property={staticProperty} />
            <Container fluid="md" className="p-0">
                <Row className="m-0">
                    <Container
                        fluid="md"
                        className="p-0 card-overlap z-index-1"
                    >
                        <Col className="p-0">
                            <SinglePropertyCard property={staticProperty} />
                        </Col>
                    </Container>
                </Row>
                <Row className="m-0 justify-content-between">
                    <Col lg={7} className="p-0">
                        <PropertyFeatures property={staticProperty} />
                        <FullDetails property={staticProperty} />
                        <HomeToSell property={staticProperty} />
                    </Col>
                    <Col lg={4} className="p-0">
                        <Nearby property={staticProperty} />
                        <InterestedCard property={staticProperty} />
                    </Col>
                </Row>
            </Container>

            <Container fluid="md" className="p-0 sticky-bar not-landscape-b">
                <BottomSticky property={staticProperty} />
            </Container>
        </>
    )
}

// export async function getStaticProps({ params }) {
//     let property = null

//     try {
//         const response = await axios.get(
//             `${process.env.API_BASE_URL}property/${params.property_ref}`,
//         )
//         property = response.data
//     } catch (err) {
//         captureException(err)
//         return {
//             notFound: true,
//         }
//     }

//     return {
//         props: {
//             staticProperty: property,
//         },
//     }
// }

// export async function getStaticPaths() {
//     try {
//         const response = await axios.get(
//             `${process.env.API_BASE_URL}property/property-refs/`,
//         )
//         const properties = response.data
//         const paths = properties.map((property) => ({
//             params: { property_ref: property.property_ref },
//         }))

//         return { paths, fallback: true }
//     } catch (err) {
//         captureException(err)
//         throw err
//     }
// }

export async function getServerSideProps({ params }) {
    let property = null

    try {
        const response = await axios.get(
            `${process.env.API_BASE_URL}property/${params.property_ref}`,
        )
        property = response.data
    } catch (err) {
        captureException(err)
        return {
            notFound: true,
        }
    }

    return {
        props: {
            staticProperty: property,
        },
    }
}

export default SinglePropertyScreen
